import React from "react";
import { Button } from "Components/Button";
import Logo from "Components/Logo";
import styles from "Styles/components/session-expired.module.css";

const SessionExpired = ({ sessionCode }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.logoWrapper}>
        <Logo />
      </div>
      <div className={styles.noisyCircleContainer} aria-hidden="true">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 1000 1000"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <radialGradient id="expired-circle-gradient" spreadMethod="repeat">
              <stop offset="0" stopColor="#1754E7" />
              <stop offset="0.5" stopColor="#2B69FF">
                <animate
                  attributeName="stopColor"
                  values="#1754E7; #2B69FF; #1754E7;"
                  dur="4s"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="offset"
                  values="0.5; 1; 0.5; 0; 0.5;"
                  dur="10s"
                  repeatCount="indefinite"
                />
              </stop>
              <stop offset="1" stopColor="#1754E7" />
            </radialGradient>
          </defs>
          <circle
            fill="url(#expired-circle-gradient)"
            cx="500"
            cy="500"
            r="500"
          />
        </svg>
        <div className={styles.noisyCircleOverlay}>
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 1000 1000"
            xmlns="http://www.w3.org/2000/svg"
          >
            <filter id="expiredNoiseFilter">
              <feTurbulence
                type="fractalNoise"
                baseFrequency="0.65"
                numOctaves="3"
                stitchTiles="stitch"
              >
                <animate
                  attributeName="baseFrequency"
                  values="0.65; 0.6"
                  dur="10s"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="numOctaves"
                  from="1"
                  to="5"
                  dur="10s"
                  repeatCount="indefinite"
                />
              </feTurbulence>
            </filter>
            <rect
              width="100%"
              height="100%"
              filter="url(#expiredNoiseFilter)"
            />
          </svg>
        </div>
        <div className={styles.noisyCircleOverlay2} />
      </div>
      <div className={styles.noisyCircleContainerRight} aria-hidden="true">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 1000 1000"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <radialGradient
              id="expired-circle-gradient-right"
              spreadMethod="repeat"
            >
              <stop offset="0" stopColor="#1754E7" />
              <stop offset="0.5" stopColor="#2B69FF">
                <animate
                  attributeName="stopColor"
                  values="#1754E7; #2B69FF; #1754E7;"
                  dur="4s"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="offset"
                  values="0.5; 1; 0.5; 0; 0.5;"
                  dur="10s"
                  repeatCount="indefinite"
                />
              </stop>
              <stop offset="1" stopColor="#1754E7" />
            </radialGradient>
          </defs>
          <circle
            fill="url(#expired-circle-gradient-right)"
            cx="500"
            cy="500"
            r="500"
          />
        </svg>
        <div className={styles.noisyCircleOverlay}>
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 1000 1000"
            xmlns="http://www.w3.org/2000/svg"
          >
            <filter id="expiredNoiseFilterRight">
              <feTurbulence
                type="fractalNoise"
                baseFrequency="0.65"
                numOctaves="3"
                stitchTiles="stitch"
              >
                <animate
                  attributeName="baseFrequency"
                  values="0.65; 0.6"
                  dur="10s"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="numOctaves"
                  from="1"
                  to="5"
                  dur="10s"
                  repeatCount="indefinite"
                />
              </feTurbulence>
            </filter>
            <rect
              width="100%"
              height="100%"
              filter="url(#expiredNoiseFilterRight)"
            />
          </svg>
        </div>
        <div className={styles.noisyCircleOverlay2} />
      </div>
      <svg
        className={styles.circleIcon}
        xmlns="http://www.w3.org/2000/svg"
        width="274"
        height="274"
        viewBox="0 0 274 274"
        fill="none"
      >
        <g clip-path="url(#clip0_5131_964)">
          <path
            d="M189.754 186.207L215.119 187.638L204.883 164.368L229.249 157.021L211.675 138.688L232.096 123.443L209.298 112.27L223.304 90.9664L198.035 88.2852L203.95 63.4941L179.263 69.6426L176.361 44.3517L155.223 58.5824L143.868 35.8415L128.831 56.4377L110.38 38.9935L103.268 63.4744L79.9501 53.4324L81.6097 78.8369L56.2382 77.4019L66.4744 100.673L42.1085 108.019L59.6829 126.352L39.2681 141.601L62.0657 152.775L48.0601 174.078L73.322 176.755L67.4142 201.55L92.1006 195.402L95.0035 220.693L116.135 206.458L127.496 229.203L142.526 208.602L160.978 226.047L168.096 201.57L191.414 211.612L189.754 186.207Z"
            fill="#FCCA23"
          />
        </g>
        <defs>
          <clipPath id="clip0_5131_964">
            <rect
              width="199.079"
              height="199.079"
              fill="white"
              transform="translate(103.092) rotate(31.1877)"
            />
          </clipPath>
        </defs>
      </svg>
      <div className={styles.card}>
        <h2 className={styles.title}>頁面已過期</h2>
        <p className={styles.errorText}>Session not found</p>
        {sessionCode && (
          <p className={styles.sessionId}>Session ID : {sessionCode}</p>
        )}
        <Button type="link" to="/">
          重新填寫
        </Button>
      </div>
    </div>
  );
};

export default SessionExpired;
